import excelente1 from "../assets/bg/excelente-avatar-1.png";

const EXCELENTE_AVATARS = [excelente1];

/**
 * URL (bundler) de un avatar «Excelente» al azar.
 * En componentes React, suele usarse dentro de useMemo([], []) para fijar uno por visita.
 */
export function getRandomExcelenteAvatar() {
	return EXCELENTE_AVATARS[Math.floor(Math.random() * EXCELENTE_AVATARS.length)];
}
